import { object, string as yupString } from 'yup'

export const LIPSYNC_TASK_TYPE = 'lipsync'

export const LYRICS_LINK_INVALID_MESSAGE =
  'Please enter a direct link to the lyrics page.'
export const LYRICS_LINK_PROVIDER_NOT_SUPPORTED_MESSAGE =
  'Only lyrics links from Musixmatch, LyricFind, or Genius are supported.'
export const LYRICS_LINK_NOT_ALLOWED_FOR_TASK_MESSAGE =
  'A lyrics link can be added only to the Lipsync task.'

export const lyricsLinkServerErrors: Record<string, string> = {
  'lyrics-link-invalid': LYRICS_LINK_INVALID_MESSAGE,
  'lyrics-link-provider-not-supported':
    LYRICS_LINK_PROVIDER_NOT_SUPPORTED_MESSAGE,
  'lyrics-link-not-allowed-for-task': LYRICS_LINK_NOT_ALLOWED_FOR_TASK_MESSAGE,
}

const LYRICS_PROVIDER_HOSTS = ['genius.com', 'lyricfind.com', 'musixmatch.com']

const parseHttpUrl = (link: string): URL | null => {
  try {
    const url = new URL(link)
    return url.protocol === 'http:' || url.protocol === 'https:' ? url : null
  } catch {
    return null
  }
}

export const getLyricsLinkError = (value?: string): string | null => {
  const link = value?.trim()
  if (!link) {
    return null
  }

  const url = parseHttpUrl(link)
  if (!url || url.pathname === '/') {
    return LYRICS_LINK_INVALID_MESSAGE
  }

  const hostname = url.hostname.toLowerCase()
  const isSupportedProvider = LYRICS_PROVIDER_HOSTS.some(
    (host) => hostname === host || hostname.endsWith(`.${host}`),
  )

  return isSupportedProvider ? null : LYRICS_LINK_PROVIDER_NOT_SUPPORTED_MESSAGE
}

export interface CommentFormValues {
  taskType: string
  comment?: string
  lyricsLink?: string
}

export const commentSchema = object().shape({
  taskType: yupString().required('Task type is required'),
  comment: yupString(),
  lyricsLink: yupString().when('taskType', {
    is: LIPSYNC_TASK_TYPE,
    then: (schema) =>
      schema.test('lyrics-link', (value, { createError }) => {
        const message = getLyricsLinkError(value)
        return message ? createError({ message }) : true
      }),
  }),
})
